export const ModalActionTypes = {
  TOGGLE_MODAL_HIDDEN: 'TOGGLE_MODAL_HIDDEN',
  TOGGLE_OPEN_SEARCH_MODAL: 'TOGGLE_OPEN_SEARCH_MODAL'
}